import { gql } from "@apollo/client";
import { Slot } from "@App/types";

export interface BlockSlotQuery {
  block: Slot;
}

export const BLOCK_SLOT = gql`
    mutation BlockSlot(
        $organization: ID!,
        $garage: ID!,
        $calendarId: ID!
        $services: [ID]!,
        $startDate: DateTimeTz!,
        $endDate: DateTimeTz!,
        $brand: ID,
        $generation: ID,
        $motorization: ID,
        $gearbox: ID,
        $body: ID,
        $mileage: Int,
        $registrationDate: Date,
        $subRepairs: [String],
        $equipments: [String],
        $premiumServices: [ID]) {
        block(
            input: {
                organization: $organization,
                from: $startDate,
                to: $endDate,
                duration: 30
                garage: $garage,
                calendar: $calendarId
                calculation: {
                    services: $services
                    brand: $brand
                    generation: $generation
                    motorization: $motorization
                    mileage: $mileage
                    gearbox: $gearbox
                    body: $body
                    registration_date: $registrationDate
                    sub_repairs: $subRepairs
                    equipments: $equipments
                    premiumServices: $premiumServices
                }
            }
        ) {
            id
            starts_at
            ends_at
            blocked_at
            session_id
            calendar_id
        }
    }
`;
